import React from 'react'
import Header from '../../components/shared/Header'
import Footer from '../../components/shared/Footer'
import Glossary from '../../images/Glossary (5).png'
function ProjectTypes() {

   const carbonData = [
    {
      title: "Fuel change project:",
      description: "A structured program that certifies and validates the environmental performance of projects, initiatives, or organizations in terms of their greenhouse gas emission reductions or sustainability practices."
    },
    {
      title: "Non-green/ Infrastructure change projects:",
      description: "Projects involving modifications, improvements, or development of physical structures, facilities, or systems, often with the aim of enhancing efficiency, sustainability or reducing environmental impacts."
    },
    {
      title: "Green/ Renewable energy projects:",
      description: "Initiatives that focus on harnessing energy from renewable sources such as solar, wind, hydro, or geothermal. These projects aim to produce electricity with lower environmental impacts compared to traditional fossil fuel-based power generation."
    },
    {
      title: "Carbon offset initiative:",
      description: "Projects or actions designed to compensate for or offset carbon emissions by removing an equivalent amount of greenhouse gases from the atmosphere. This can involve activities such as reforestation, renewable energy projects, or methane capture initiatives."
    }
  ];


  const CarbonItem = ({ title, description }) => {
  return (
    <div className="flex flex-col items-start p-0 gap-4 w-full max-w-[1152px]">
      <h3 className="text-[24px] font-medium text-2xl leading-[29px] text-[#141414]">
        {title}
      </h3>
      <p className="w-full  font-normal text-[16px] leading-[150%] text-[#141414]">
        {description}
      </p>
    </div>
  );
};
  return (
    <>
    <Header/>
    <div className="relative w-full max-w-[1440px] h-[933px] top-[0px] mx-auto">
      {/* Text Section */}
      <div className="absolute w-full max-w-[1200px] h-[76px] left-1/2 transform -translate-x-1/2 top-[82px] flex flex-col items-center p-0 gap-10">
        <h1 className="w-full max-w-[688px] h-[76px] font-['SF_Pro_Display'] font-medium text-6xl leading-[76px] text-center text-[#141414]">
Project Types        </h1>
      </div>

      {/* Image Section */}
      <img 
        className="absolute w-full max-w-[1200px] h-[552px] left-1/2 transform -translate-x-1/2 top-[275px] rounded-2xl  object-fill"
        src={Glossary}
        alt="Carbon Incentive"
      />
    </div>


 <div className="w-full max-w-[1200px] mx-auto mt-20 mb-20 flex flex-col items-start gap-8">
      <h2 className=" font-bold text-[32px] leading-[38px] text-[#0D924F]">
Project Types
      </h2>
      <div className="flex flex-col gap-6 w-full">
        {carbonData.map((item, index) => (
          <CarbonItem 
            key={index}
            title={item.title}
            description={item.description}
          />
        ))}
      </div>
    </div>
    <Footer/>
    </>



  )
}

export default ProjectTypes


